import { EntityConfig } from 'angular-odata';

//#region ODataApi Imports
import { WettbewerberPreisGroup } from './wettbewerberpreisgroup.entity';
//#endregion

export const WettbewerberPreisGroupConfig = {
  name: "WettbewerberPreisGroup",
  annotations: [],
  fields: {
    wettbewerberPreisId: {type: 'Edm.Int32'},
    groupId: {type: 'Edm.Int32'},
    statusId: {type: 'Edm.Int32'},
    statusTypeId: {type: 'Edm.Int32'},
    statusAt: {type: 'Edm.DateTimeOffset'},
    statusBy: {type: 'Edm.String'},
    createdBy: {type: 'Edm.String'},
    id: {type: 'Edm.Int32', key: true, ref: 'id', nullable: false},
    wettbewerberPreis: {type: 'entities.wettbewerb.WettbewerberPreis', navigation: true, field: 'wettbewerberPreisId', ref: 'id'},
    group: {type: 'entities.schema.Group', navigation: true, field: 'groupId', ref: 'id'},
    status: {type: 'entities.settings.Status', navigation: true, field: 'statusId', ref: 'id'},
    statusType: {type: 'entities.settings.StatusType', navigation: true, field: 'statusTypeId', ref: 'id'}
  }
} as EntityConfig<WettbewerberPreisGroup>;